import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, database } from "../firebase/firebaseConfig";
import { ref, get } from "firebase/database";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [userLoading, setUserLoading] = useState(true);

    useEffect(() => {

        const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
            try {

                setUserLoading(true);

                // ❌ no user
                if (!authUser) {
                    setCurrentUser(null);
                    setUserLoading(false);
                    return;
                }

                // ⚡ instant basic user (NO delay UI)
                const baseUser = {
                    uid: authUser.uid,
                    email: authUser.email,
                };

                // 🔥 fetch realtime DB profile
                const userRef = ref(database, `Users/${authUser.uid}`);
                const snap = await get(userRef);

                if (snap.exists()) {
                    setCurrentUser({
                        ...baseUser,
                        ...snap.val(),
                    });

                }

            } catch (error) {
                console.error("AuthContext error:", error);
                setCurrentUser(null);
            } finally {
                setUserLoading(false);
            }
        });

        return () => {
            unsubscribe();
        };
    }, []);

    return (
        <AuthContext.Provider value={{ currentUser, userLoading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
